/**
 * nextEpisode.tsx
 */
import Button from '../buttons/ui/nextEpisodeButton';
import Container from '../../atoms/container/nextEpisodeContainer';
import Focus from '@shared/types/enums/focus';
import List from '../../sections/list/list';
import TranslationManager from '@shared/assets/locale/translationsManager';
import useKeyboard from '@shared/components/utils/hooks/useKeyboard';
import { PlayerState } from '@shared/types/enums/player';
import { mediaSelector } from '@shared/store/slices/media.slice';
import { playerSelector } from '@shared/store/slices/player.slice';
import { setFocus } from '@shared/store/slices/focus.slice';
import { useAppDispatch, useAppSelector } from '@shared/store/hooks';
import { useCallback, useEffect } from 'react';
import {
  loadSeasonExtended,
  playerEndAction,
} from '@shared/store/thunks/player.thunk';

/**
 * Displays the next episode layout.
 */
export default function NextEpisode() {
  // Dispatch
  const dispatch = useAppDispatch();

  // Selectors
  const { state } = useAppSelector(mediaSelector);

  // Get next episode action remaining time and display mode

  const {
    nextEpisode: { asset, display, percentage },
  } = useAppSelector(playerSelector);

  // Get episode and season letter literals

  const { episodeNumber, seasonNumber } = asset || {};
  const episodeLetter = episodeNumber ? asset?.getEpisodeNumber() : '';
  const seasonLetter = seasonNumber ? asset?.getSeasonNumber() : '';

  // Get next episode buttons text

  const episodesText = `${TranslationManager.get(
    'MISC.EPISODES'
  )} ${seasonLetter}`;
  const nextEpisodeText = `${TranslationManager.get('MISC.NEXT')}${
    seasonLetter || episodeLetter ? ' | ' : ''
  }${seasonLetter}${episodeLetter}`;

  // Actions

  const focusPilot = useCallback(() => {
    dispatch(setFocus(Focus.PLAYER));
  }, []);

  // Effect hook

  useEffect(() => {
    if (display && ![PlayerState.SEEK, PlayerState.SEEKING].includes(state)) {
      dispatch(setFocus(Focus.NEXT_EPISODE));
    } else {
      focusPilot();
    }
  }, [display]);

  // Keyboard hook

  useKeyboard({
    focus: Focus.NEXT_EPISODE,
    keyDownHandler: (key) => {
      switch (key) {
        case 'DOWN':
        case 'SELECT':
          setTimeout(() => {
            focusPilot();
          });
          break;
      }
    },
  });

  return asset && display ? (
    <Container>
      <List focus={Focus.NEXT_EPISODE}>
        <Button
          action={() => {
            dispatch(playerEndAction());
          }}
          fill={percentage}
          index={0}
          text={nextEpisodeText}
        />
        <Button
          action={() => {
            dispatch(loadSeasonExtended());
          }}
          index={1}
          text={episodesText}
        />
      </List>
    </Container>
  ) : null;
}
